import ClaudeCodeMark from "../../assets/McpClients/claude-code.svg?react";
import ClaudeMark from "../../assets/McpClients/claude.svg?react";
import CodexMark from "../../assets/McpClients/codex.svg?react";
import CursorMark from "../../assets/McpClients/cursor.svg?react";
import WindsurfMark from "../../assets/McpClients/windsurf.svg?react";

import type { McpClientSlug } from "./mcpClients";

type LogoComponent = React.FunctionComponent<React.SVGAttributes<SVGElement>>;

/**
 * Monochrome brand marks, kept out of mcpClients.ts so that file stays plain
 * data. Every mark is a 24x24 single-path SVG using fill="currentColor", so one
 * asset serves the light cards and the dark install card without a second file.
 *
 * Callers still handle a null mark: the grid reserves the slot height either
 * way, so adding a sixth client never leaves a row misaligned.
 */
const LOGOS: Partial<Record<McpClientSlug, LogoComponent>> = {
  "claude-code": ClaudeCodeMark,
  cursor: CursorMark,
  claude: ClaudeMark,
  windsurf: WindsurfMark,
  codex: CodexMark,
};

export const mcpClientLogo = (slug: McpClientSlug): LogoComponent | null =>
  LOGOS[slug] ?? null;
